import { Routes, Route, Navigate } from 'react-router-dom';
import { Chart } from '../pages/Chart';
import { Region } from '../pages/Region';
import { ArtistProfile } from '../pages/ArtistProfile';
import { About } from '../pages/About'
import { Top100 } from '../pages/Top100';
import GenreFeed from "../pages/GenreFeed";
import { Terms } from '../pages/Terms';
import { PrivacyPolicy } from '../pages/PrivacyPolicy';
import { ScrollToTop } from '../utils/ScrollToTop';

import { Admin } from "../pages/Admin"
import {App} from '../App';


export const AppRoutes = () => {
    
    return (
      <>

      <ScrollToTop />

      <Routes>
        <Route path="/" element={<App />} />
        <Route path="/admin" element={<Admin />} />
        <Route path="/chart/:stateNameAlias" element={<Chart />} />
        <Route path="/region/:regionNameAlias" element={<Region />} />
        <Route path="/artist/:userName" element={<ArtistProfile />} />
        <Route path="/about" element={<About />} />
        <Route path="top100" element={<Top100 />} />
        <Route path="/genres/:genre" element={<GenreFeed />} />
        <Route path="/terms" element={<Terms />} />
        <Route path="/privacy" element={<PrivacyPolicy />} />
      </Routes>
      
      </>
    );
}


